import Gravity from 'Gravity';

const initAttestation = () => {
    const attestation = document.querySelector('.gg-attestation');

    if (!attestation) {
        return;
    }

    const investorButtons = attestation.querySelectorAll('.gg-attestation__investor-buttons .wp-block-button');
    const allFunctionalButtons = attestation.querySelectorAll('.wp-block-button__link');
    const loader = attestation.querySelector('.gg-attestation__loader');
    const privacyCheckError = attestation.querySelector('.gg-attestation__privacy-check-error');
    const navigationMobileToggleButton = document.querySelector('.gravity-block-navigation__mobile-toggle');
    const groupSubmitBtn = document.querySelector('.gg-attestation__submit-buttons');
    const btnAttestation = document.querySelector('.gg-attestation__submit-buttons a:not(.gg-attestation__btn-submit-fake)');
    const btnAttestationFake = document.querySelector('.gg-attestation__submit-buttons .gg-attestation__btn-submit-fake');
    const attestationTrigger = document.querySelector('.attestation-trigger');
    const investorCookieValue = Gravity.getCookie('attestationAccept');
    const groupInvestor = attestation.querySelector('.gg-attestation__group-investor');
    const hideAttestationCookieValue = Gravity.getCookie('attestationAccept');
    const milliseconds = 86400000;
    const cookieDays = 90;
    const responseStatus = 200;
    const investors = ['institutional/', 'financial-advisor/', 'individual/', 'non-us/'];
    const investorButtonActiveClass = 'active';
    // let activeInvestorLink = null;

    // Start attestation cookie logic
    const attestationVisibilityHandler = (state, dataAttrElement, dataAttr) => {
        dataAttrElement.setAttribute(dataAttr, state);
        attestation.focus();

        if (state) {
            setTabindexForAllButtons('0');
        }

        if (
            document.body.classList.contains('gravity-block-navigation--mobile-open') &&
            attestation.getAttribute('data-hide') === 'false'
        ) {
            Gravity.clickEnterListener(attestationTrigger, navigationMobileToggleButton.click());
        }
    };
    const getUrlParameters = (options = {}) => {
        try {
            const {
                asObject = false,
                excludeParams = [],
                includeQuestionMark = false
            } = options;
    
            const searchParams = new URLSearchParams(window.location.search);
            const params = {};
    
            // Convert to object if requested
            if (asObject) {
                searchParams.forEach((value, key) => {
                    if (!excludeParams.includes(key)) {
                        params[key] = value;
                    }
                });
                return params;
            }
    
            // Convert to string
            let paramString = Array.from(searchParams.entries())
                .filter(([key]) => !excludeParams.includes(key))
                .map(([key, value]) => `${key}=${value}`)
                .join('&');
    
            if (paramString == '') {
                return '';
            }
            return includeQuestionMark ? `?${paramString}` : paramString;
        } catch (error) {
            console.error('Error getting URL parameters:', error);
            return asObject ? {} : '';
        }
    }

    const cookieExpiration = (days) => {
        const date = new Date();
        date.setTime(date.getTime() + days * milliseconds);
        return date.toGMTString();
    };

    const attestationCookieHandler = (state, cookieName, dataAttr) => {
        const cookieExpiryDate = state ? cookieDays : -cookieDays;
        attestation.setAttribute(dataAttr, state);

        Gravity.setCookie(cookieName, state, {
            path: '/',
            expires: cookieExpiration(cookieExpiryDate),
        });
    };

    const setTabindexForAllButtons = (value) => {
        allFunctionalButtons.forEach((functionalButton) => {
            functionalButton.setAttribute('tabindex', value);
        });
    };

    // redirects

    const handleInvestorRedirect = async (link) => {
        const siteUrl = link.dataset.href;
        const pageSlug = filterPathname(window.location.pathname.replace('/financial-advisor', '').replace('/institutional', '').replace('/non-us', '').replace('/individual', ''));
        const cleanPageSlug = pageSlug.replace(/^\//, '');
        const normalizedSiteUrl = siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl;
        const targetUrl = `${normalizedSiteUrl}/${cleanPageSlug}`;
        const pageExists = await checkIfPageExists(targetUrl);
        if (pageExists) {
            window.location.href = targetUrl;
            return;
        }
        window.location.href = siteUrl;
    };

    const checkIfPageExists = async (url) => {
        let pageExistence;

        try {
            const response = await fetch(url);
            if (response.status === responseStatus) {
                pageExistence = true;
            }
        } catch (e) {
            pageExistence = false;
        }
        return pageExistence;
    };

    const filterPathname = (pathname) => investors.reduce((acc, inv) => acc.replaceAll(inv, ''), pathname);

    const handleRedirectOnButton = async (e) => {
        e.preventDefault();
        const link = e.target.closest('a');

        if (!link) {
            return;
        }

        // if (!activeInvestorLink) {
        //     activeInvestorLink?.classList.remove(investorButtonActiveClass);
        //     link.classList.add(investorButtonActiveClass);

        //     activeInvestorLink = link;

        //     return;
        // }

        handleInvestorRedirect(link);
    };

    // set cookie on click button in attestation popup
    investorButtons.forEach((investorButton) => {
        investorButton.addEventListener('click', (e) => {
            e.preventDefault();
            handleRedirectOnButton(e);
        });
    });

    // show attestation popup on top menu click

    // close attestation on click outside
    Gravity.clickEnterListener(document, (e) => {
        if (attestation.getAttribute('data-hide') === 'false') {
            const isMobileCloseButton =
                navigationMobileToggleButton.contains(e.target) &&
                !document.body.classList.contains('gravity-block-navigation--mobile-open');
            const isOutsideAttestation =
                !attestation.contains(e.target) && !attestationTrigger.contains(e.target) && !isMobileCloseButton;
        }
    });

    // change investor type label base on selected investor
    const investorTypeButton = document.querySelector('.attestation-trigger .wp-block-button__link');
    const investorsNames = ['institutional', 'financial-advisor', 'individual', 'non-us'];

    if (investorTypeButton) {
        const currentPath = window.location.pathname;
        const pathWithoutLeadingSlash = currentPath.startsWith('/') ? currentPath.substring(1) : currentPath;
        const matchingInvestor = investorsNames.find((investor) => pathWithoutLeadingSlash.includes(investor));

        if (matchingInvestor) {
            let investorLabel = matchingInvestor.replace('-', ' ');
            if (matchingInvestor === 'non-us') {
                investorLabel = matchingInvestor;
            }
            investorTypeButton.textContent = investorLabel;
        }
    }

    // close attestation on click
    attestationVisibilityHandler(!!investorCookieValue, attestation, 'data-active');

    attestationVisibilityHandler(!!hideAttestationCookieValue, attestation, 'data-hide');

    // render list button to list dropdown

    const handleCheckState = (state) => {
        if (state) {
            attestationCookieHandler(state, 'attestationAccept', 'data-active');
        } else {
            attestationCookieHandler(false, 'attestationAccept', 'data-active');
        }
    }

    const handleRenderListOption = (parentElement, captionText) => {
        const dropdown = document.createElement('div');
        dropdown.className = 'dropdown';
    
        const caption = document.createElement('div');
        caption.className = 'caption selected';
        caption.textContent = captionText;
        dropdown.appendChild(caption);
    
        const list = document.createElement('div');
        list.className = 'list';
        dropdown.appendChild(list);
    
        // Adding the custom caption item without href
        const customCaptionItem = document.createElement('div');
        customCaptionItem.className = 'item';
        customCaptionItem.textContent = captionText.replace(/^\d+\.\s*/, '')
        list.appendChild(customCaptionItem);
    
        const options = parentElement.querySelectorAll('p, .wp-block-button a');
        options.forEach(option => {
            const item = document.createElement('div');
            item.className = 'item';
            item.textContent = option.textContent;
            item.dataset.href = option.href || option.dataset.href;
            list.appendChild(item);
        });
        parentElement.innerHTML = '';
        parentElement.appendChild(dropdown);
    
        caption.addEventListener('click', (e) => {
            const clickedDropdown = e.target.closest('.dropdown');
            if (clickedDropdown) {
                document.querySelectorAll('.gg-attestation__group-selection .dropdown').forEach(dropdown => {
                    if (dropdown !== clickedDropdown) {
                        dropdown.classList.remove('open');
                    }
                });
                clickedDropdown.classList.toggle('open');
            }
        });
        
        
    
        list.addEventListener('click', event => {
            if (event.target && event.target.classList.contains('item')) {
                const selected = list.querySelector('.selected');
                if (selected) {
                    selected.classList.remove('selected');
                }
                event.target.classList.add('selected');
                caption.textContent = event.target.textContent;
                dropdown.classList.remove('open');
            
                const isSelectText = event.target.textContent.toLowerCase().includes('select');
                const isInGroupInvestor = event.target.closest('.gg-attestation__group-investor');
                const isInGroupOptionUS = event.target.closest('.gg-attestation__group-option-us');
                const isTheUS = event.target.textContent.toLowerCase() === 'u.s.';
                const isNonUS = event.target.textContent.toLowerCase() === 'non-u.s.';
                const captionItems = groupInvestor.querySelectorAll('.caption');
                const selectedUsItem = document.querySelector('.gg-attestation__group-us .item.selected');
                const nonUsItemFirst = document.querySelectorAll('.gg-attestation__group-non-us .item')[1];
            
                if (isSelectText && !isInGroupInvestor) {
                    btnAttestation.removeAttribute('data-href');
                    captionItems.forEach(item => {
                        item.classList.add('selected');
                    });
                    groupInvestor.style.pointerEvents = 'none';
                } else {
                    btnAttestation.dataset.href = event.target.dataset.href;
                }

                const state = true;
            
                if (isInGroupOptionUS && !isSelectText) {
                    captionItems.forEach(item => {
                        item.classList.remove('selected');
                    });
                    groupInvestor.style.pointerEvents = 'visible';

                    handleCheckState(state);
                    
                    if (isTheUS) {
                        if (selectedUsItem && selectedUsItem.dataset.href) {
                            btnAttestation.dataset.href = selectedUsItem.dataset.href + getUrlParameters({includeQuestionMark: true});
                        } else {
                            btnAttestation.dataset.href = window.location.origin + '/' + getUrlParameters({includeQuestionMark: true});
                        }
                    }
            
                    if (isNonUS) {
                        if( nonUsItemFirst && nonUsItemFirst.dataset.href) {
                            btnAttestation.dataset.href = nonUsItemFirst.dataset.href + getUrlParameters({includeQuestionMark: true});
                        }
                    }
                }

                if (isInGroupOptionUS) {
                    document.querySelector('.gg-attestation__group-option-us .caption').classList.remove('error-selected');
                    if (!isSelectText) {
                        groupSubmitBtn.classList.remove('show-fake');
                    } else {
                        groupSubmitBtn.classList.add('show-fake');
                    }
                    if (!isSelectText) {
                        handleCheckState(state);
                    } else {
                        attestationCookieHandler(false, 'attestationAccept', 'data-active')
                    }
                }
            
                if (isInGroupInvestor && isSelectText) {
                    if (event.target.closest('.gg-attestation__group-us')) {
                        btnAttestation.dataset.href = window.location.origin + '/' + getUrlParameters({includeQuestionMark: true});
                    } else {
                        btnAttestation.dataset.href = document.querySelectorAll('.gg-attestation__group-non-us .item')[1].dataset.href + getUrlParameters({includeQuestionMark: true});
                    }
                }
            }
            
        });
    
        document.addEventListener('click', event => {
            if (!event.target.closest('.dropdown > .caption')){
                dropdown.classList.remove('open');
            }
        });
    };
    
    const initializeOptions = () => {
        const parentElements = [
            { selector: '.gg-attestation__group-option-us', caption: '1. SELECT REGION' },
            { selector: '.gg-attestation__group-us', caption: '2. SELECT INVESTOR  TYPE' },
            { selector: '.gg-attestation__group-non-us', caption: '2. SELECT INVESTOR  TYPE' }
        ];
    
        parentElements.forEach(config => {
            const parentElement = document.querySelector(config.selector);
            if (parentElement) {
                handleRenderListOption(parentElement, config.caption);
            }
        });
    };
    
    initializeOptions();

    document.querySelectorAll('.gg-attestation__group-option-us .item').forEach((item) => {
        item.addEventListener('click', () => {
            const usInvestor = document.querySelector('.gg-attestation__group-us');
            const nonUsInvestor = document.querySelector('.gg-attestation__group-non-us');
            if (item.textContent === 'U.S.') {
                nonUsInvestor.style.opacity = '0';
                nonUsInvestor.style.visibility = 'hidden';
                usInvestor.style.opacity = '1';
                usInvestor.style.visibility = 'visible';
            } else {
                usInvestor.style.opacity = '0';
                usInvestor.style.visibility = 'hidden';
                nonUsInvestor.style.opacity = '1';
                nonUsInvestor.style.visibility = 'visible';
            }
        });
    });

    const captionOptionUs = document.querySelector('.gg-attestation__group-option-us .caption')

    btnAttestation.addEventListener('click', (e) => {
        e.preventDefault()
        if (attestation.getAttribute('data-active') === 'true' && btnAttestation.dataset.href === '') {
            groupSubmitBtn.classList.add('show-fake');
            return;
        }
        if (btnAttestation.dataset.href === window.location.href) {
            attestationVisibilityHandler(true, attestation, 'data-hide');
            localStorage.setItem('hideAttestationCookie', true);
        } else {
            handleRedirectOnButton(e)
        }
    })

    const handleCheckError = () => {
        if (document.querySelector('.gg-attestation__group-option-us .caption').textContent.toLowerCase().includes('select')) {
            captionOptionUs.classList.add('error-selected');
        } else {
            captionOptionUs.classList.remove('error-selected');
        }
    }

    btnAttestationFake.addEventListener('click', () => {
        handleCheckError()
        privacyCheckError.classList.remove('show-error');
        console.log('clicked');
        
    });

    if (document.querySelector('.gg-attestation__group-option-us .caption').textContent.toLowerCase().includes('select') && attestation.getAttribute('data-active') == 'true') {
        groupSubmitBtn.classList.add('show-fake');
    }

    Gravity.clickEnterListener(attestationTrigger, () => {
        attestationVisibilityHandler(false, attestation, 'data-hide');
        attestationCookieHandler(false, 'attestationAccept', 'data-active');
        document.querySelectorAll('.gg-attestation__group-selection .list').forEach(list => {
            if (list.querySelector('.item.selected')) {
                list.querySelectorAll('.item')[0].click();
            }
        });
    });
};

export default initAttestation;
